import { render, staticRenderFns } from "./CgrnView.vue?vue&type=template&id=1c3bef14&scoped=true"
import script from "./CgrnView.vue?vue&type=script&lang=js"
export * from "./CgrnView.vue?vue&type=script&lang=js"
import style0 from "./CgrnView.vue?vue&type=style&index=0&id=1c3bef14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3bef14",
  null
  
)

export default component.exports